// Lib
import React from 'react';
import { Button } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useStyles } from './EditRecurrenceButtonStyles';

const EditRecurrenceButton = ({ onClick = () => {} }) => {
  const { classes, cx } = useStyles();

  return (
    <Button
      onClick={onClick}
      className={cx(classes.clickable, classes.flatButton)}
      startIcon={<EditOutlinedIcon />}
      data-testid="edit-recurrence-button">
      Edit Recurrence
    </Button>
  );
};

export default EditRecurrenceButton;
